
export default class CaptchaService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    captcha(service) {
        return this.axios
            .get(`/${service}/captcha`, { responseType: "blob" })
            .catch(this.snackbar.catch())
            .then(response => ({ captcha: response.headers["x-captcha"], image: response.data }));
    }

}
